import { CommonGet, CommonPost } from '../../helpers/HttpClient';
import tokenDecoder from '../../utils/tokenDecoder';

export default {
  getfactoriesForDropDown,
  getGroupsForDropdown,
  getFactoriesByGroupID,
  getAllFactories,
  getAccountTypeNamesForDropdown,
  getTransactionTypeNamesForDropdown,
  getReferenceNumber,
  saveAccountPayable,
  getAccountPayableDetails,
  getTransactionTypeList,
  getAccountPayableDetailsByReferenceNumber,
  updateAccountPayable,
  approveAccountPayable,
  getLedgerAccountNamesForDropdown,
  getVoucherTypeList,
  getTransactionModeList,
  getLedgerAccountNamesForDatagrid,
  getFinancialYearStartDateByGroupIDFactoryID,
  getChequeNumber,
  rejectAccountPayable,
  getAccountDescriptions,
  getAccountDescriptionsNormal,
  getSuppliersForDropDownAuto,
  getSuppliersForDropDown,
  getTranLedgerListForDropdown,
  getTranLedgerListForAutoDropdown,
  getChildHeaderNamesForDatagrid,
  getSupplierInvoiceNumbersBySupplier
};

async function getAllFactories() {
  var factoryArray = [];
  const response = await CommonGet('/api/Factory/GetAllFactories', null);
  for (let item of Object.entries(response.data)) {
    factoryArray[item[1]["factoryID"]] = item[1]["factoryName"];
  }
  return factoryArray;
}

async function getFactoriesByGroupID(groupID) {
  var factoryArray = [];
  const response = await CommonGet('/api/Group/GetFactoryByGroupID', "groupID=" + parseInt(groupID));
  for (let item of Object.entries(response.data)) {
    factoryArray[item[1]["factoryID"]] = item[1]["factoryName"];
  }
  return factoryArray;
}

async function getfactoriesForDropDown(groupID) {
  var factoryArray = [];
  const response = await CommonGet('/api/Group/GetFactoryByGroupID', 'groupID=' + groupID)
  for (let item of Object.entries(response.data)) {
    factoryArray[item[1]["factoryID"]] = item[1]["factoryName"]
  }
  return factoryArray;
}

async function getGroupsForDropdown() {
  var groupArray = [];
  const response = await CommonGet('/api/Group/GetAllGroups', null)
  for (let item of Object.entries(response.data)) {
    if (item[1]["isActive"] === true) {
      groupArray[item[1]["groupID"]] = item[1]["groupName"]
    }
  }
  return groupArray;
}

async function getAccountTypeNamesForDropdown(groupID, factoryID) {
  const response = await CommonGet('/api/AccountType/GetAccountTypeNamesForDropdown',
    "groupID=" + parseInt(groupID) + "&factoryID=" + parseInt(factoryID));
  let array = ["Select Account "]
  for (let item of Object.entries(response.data)) {
    array[item[1]["accountTypeID"]] = item[1]["accountTypeName"]
  }
  return array;
}

async function getTransactionTypeNamesForDropdown() {
  var transactionArray = [];
  const response = await CommonGet('/api/ManualUploadTransaction/GetTransactionTypes', null)
  for (let item of Object.entries(response.data)) {
    transactionArray[item[1]["transactionTypeID"]] = item[1]["transactionTypeName"]
  }
  return transactionArray;
}

async function getReferenceNumber(model) {
  const response = await CommonGet('/api/AccountPayable/GetReferenceCodeForAccountPayable', 'groupID=' + model.groupID + '&factoryID='
    + model.factoryID + '&voucherYear=' + model.date + '&voucherCode=' + model.voucherCode);
  return response;
}

async function saveAccountPayable(model) {
  let saveModel = {
    ledgerTransactionID: 0,
    groupID: parseInt(model.groupID.toString()),
    factoryID: parseInt(model.factoryID.toString()),
    transactionTypeID: parseInt(model.transactionTypeID),
    referenceNumber: (model.referenceNumber.toString()),
    payableReferenceNumber: (model.payableReferenceNumber.toString()),
    referenceNumberInter: (model.referenceNumberInter.toString()),
    chequeNumber: model.chequeNumber,
    voucherType: parseInt(model.voucherType),
    transactionMode: parseInt(model.transactionMode.toString()),
    transactionModeName: model.transactionModeName,
    voucherCode: model.voucherCode,
    recipientName: model.recipientName,
    isActive: true,
    journalData: model.journalData,
    transactionDate: model.transactionDate,
    invoiceNo: model.invoiceNo,
    invoiceDate: model.invoiceDate,
    date: model.invoiceDate,
    dueDate: model.dueDate,
    createdBy: tokenDecoder.getUserIDFromToken(),
    preparedBy: tokenDecoder.getUserIDFromToken(),
    interEstateID: parseInt(model.interEstateID.toString()),
    isInterEstate: model.isInterEstate,
    createdDate: new Date().toISOString(),
    status: parseInt(model.status.toString()),
    supplierID: parseInt(model.supplierID.toString()),
    supplierName: model.supplierName,
    payableDescription: model.payableDescription,
    tranLedgerAccountID: parseInt(model.tranLedgerAccountID.toString()),
    tranLedgerAccountName: model.tranLedgerAccountName
  }
  
  const response = await CommonPost('/api/AccountPayable/SaveAccountPayable', null, saveModel);
  return response;
}

async function getAccountPayableDetails(model) {
  const response = await CommonPost('/api/AccountPayable/GetAccountPayableDetails', null, model);
  return response;
}

async function getTransactionTypeList() {
  const response = await CommonGet('/api/ManualUploadTransaction/GetTransactionTypes', null)
  return response.data;
}

async function getAccountPayableDetailsByReferenceNumber(model) {
  const response = await CommonPost('/api/AccountPayable/GetAccountPayableDetailsByReferenceNumber', null, model);
  return response.data;
}

async function updateAccountPayable(model) {
  let updateModel = {
    ledgerTransactionID: 0,
    invoiceDetailID: parseInt(model.invoiceDetailID),
    groupID: model.groupID,
    factoryID: model.factoryID,
    transactionTypeID: parseInt(model.transactionTypeID),
    referenceNumber: (model.referenceNumber.toString()),
    payableReferenceNumber: (model.payableReferenceNumber.toString()),
    voucherType: parseInt(model.voucherType),
    transactionMode: parseInt(model.transactionMode),
    recipientName: model.recipientName,
    chequeNumber: model.chequeNumber,
    isActive: true,
    journalData: model.journalData,
    date: model.date,
    dueDate: model.dueDate,
    updatedBy: tokenDecoder.getUserIDFromToken(),
    modifiedBy: tokenDecoder.getUserIDFromToken(),
    modifiedDate: new Date().toISOString(),
    voucherCode: model.voucherCode
  }
  const response = await CommonPost('/api/AccountPayable/UpdateAccountPayable', null, updateModel);
  return response;
}

async function approveAccountPayable(model) {
  let approveModel = {
    ledgerTransactionID: 0,
    invoiceDetailID: parseInt(model.invoiceDetailID),
    groupID: model.groupID,
    factoryID: model.factoryID,
    transactionTypeID: parseInt(model.transactionTypeID),
    referenceNumber: (model.referenceNumber.toString()),
    payableReferenceNumber: (model.payableReferenceNumber.toString()),
    voucherType: parseInt(model.voucherType),
    transactionMode: parseInt(model.transactionMode),
    recipientName: model.recipientName,
    chequeNumber: model.chequeNumber,
    isActive: true,
    journalData: model.journalData,
    date: model.date,
    dueDate: model.dueDate,
    //updatedBy: tokenDecoder.getUserIDFromToken(),
    //modifiedBy: tokenDecoder.getUserIDFromToken(),
    createdBy: tokenDecoder.getUserIDFromToken(),
    preparedBy: tokenDecoder.getUserIDFromToken(),
    modifiedDate: new Date().toISOString(),
    voucherCode: model.voucherCode
  }
  const response = await CommonPost('/api/AccountPayable/ApproveAccountPayable', null, approveModel);
  return response;
}

async function getLedgerAccountNamesForDropdown(groupID, factoryID) {
  const response = await CommonGet('/api/LedgerAccount/GetLedgerAccountNamesForDropdown',
    "groupID=" + parseInt(groupID) + "&factoryID=" + parseInt(factoryID));
  let array = ["Select Account "]
  for (let item of Object.entries(response.data)) {
    array[item[1]["ledgerAccountID"]] = item[1]["ledgerAccountName"]
  }
  return array;
}

async function getVoucherTypeList() {
  const response = await CommonGet('/api/VoucherType/GetAllVoucherTypes', null)
  return response.data;
}

async function getTransactionModeList() {
  const response = await CommonGet('/api/AccountPayable/GetAllTransactionModes', null)
  return response.data;
}

async function getChildHeaderNamesForDatagrid(groupID, factoryID) { 
  const response = await CommonGet('/api/LedgerAccount/GetChildHeaderNamesForDropdown',
    "groupID=" + parseInt(groupID) + "&factoryID=" + parseInt(factoryID));
  let data = response.data;
  let result = data.map((u) => ({ childHeaderName: u.childHeaderName, childHeaderID: u.childHeaderID }));
  return result;
}

async function getLedgerAccountNamesForDatagrid(childHeaderModel) {
  const response = await CommonPost('/api/LedgerAccount/GetLedgerAccountNamesForJournal', null, childHeaderModel);
  let data = response.data;
  let result = data.map((u) => ({ ledgerAccountName: u.ledgerAccountName, ledgerAccountID: u.ledgerAccountID }));
  return result;
}

async function getFinancialYearStartDateByGroupIDFactoryID(groupID, factoryID) {
  const response = await CommonGet('/api/GeneralJournal/GetFinancialYearStartDateByGroupIDFactoryID',
    "groupID=" + parseInt(groupID) + "&factoryID=" + parseInt(factoryID));
  return response.data;
}

async function getChequeNumber(ledgerAccountID) {
  const response = await CommonGet('/api/ChequeNumberSequence/GetChequeNumberByLedgerAccountID', "ledgerAccountID=" + parseInt(ledgerAccountID));
  return response;
}

async function rejectAccountPayable(model) {
  let rejectModel = {
    invoiceDetailID: parseInt(model.invoiceDetailID),
    groupID: parseInt(model.groupID.toString()),
    factoryID: parseInt(model.factoryID.toString()),
    referenceNumber: model.referenceNumber.toString(),
    rejectRemark: model.rejectRemark.toString(),
    modifiedBy: tokenDecoder.getUserIDFromToken()
  }
  const response = await CommonPost('/api/AccountPayable/RejectAccountPayableByReferenceNumber', null, rejectModel);
  return response;
}

async function getAccountDescriptions(accountID) {
  const response = await CommonGet('/api/AccountType/GetAccountDescriptions', "accountID=" + parseInt(accountID));
  return response.data;
}

async function getAccountDescriptionsNormal(accountID) {
  const response = await CommonGet('/api/AccountType/GetAccountDescriptions', "accountID=" + parseInt(accountID));
  let array = []
  for (let item of Object.entries(response.data)) {
    array[item[1]["accountDescriptionTypeID"]] = item[1]["accountDescription"]
  }
  return array;
}

async function getSuppliersForDropDownAuto(factoryID) {
  const response = await CommonGet('/api/AccountingSuppliers/GetSuppliersForDropDown', "factoryID=" + parseInt(factoryID));
  return response.data;
}

async function getSuppliersForDropDown(factoryID) {
  var supplierArray = [];
  const response = await CommonGet('/api/AccountingSuppliers/GetSuppliersForDropDown', "factoryID=" + parseInt(factoryID));
  for (let item of Object.entries(response.data)) {
    supplierArray[item[1]["supplierID"]] = { name: item[1]["supplierName"], code: item[1]["supplierCode"] }
  }
  return supplierArray;
}

async function getTranLedgerListForDropdown(factoryID) {
  var ledgerArray = [];
  const response = await CommonGet('/api/AccountPayable/GetTranLedgerListForDropdown', "factoryID=" + parseInt(factoryID));
  for (let item of Object.entries(response.data)) {
    ledgerArray[item[1]["ledgerAccountID"]] = item[1]["ledgerAccountName"];
  }
  return ledgerArray;
}

async function getTranLedgerListForAutoDropdown(factoryID) {
  const response = await CommonGet('/api/AccountPayable/GetTranLedgerListForDropdown', "factoryID=" + parseInt(factoryID));
  return response.data;
}

async function getSupplierInvoiceNumbersBySupplier(groupID, factoryID, supplierID) {
  let response = await CommonGet('/api/AccountPayable/GetSupplierInvoiceNumbersBySupplier', 'groupID=' +  parseInt(groupID) + '&factoryID=' +  parseInt(factoryID) + '&supplierID=' +  parseInt(supplierID));
  return response;
}
 
